import "./audiomenu.scss";
import React from "react";
import { Toggle } from "@onshopfront/components";
import Button from "../../../Common/Buttons/Button";

interface Props {
    name: string;
    onComplete: (approved: boolean, remember: boolean) => void;
}

const AudioRequestDialog: React.FunctionComponent<Props> = (props) => {
    const [ remember, setRemember ] = React.useState(false);

    return (
        <>
            <div id="audio-permission">
                <p>
                    Give permission for the integration <b>{props.name}</b> to play audio?
                </p>
                <label className="flex items-center gap-2">
                    <Toggle
                        checked={remember}
                        onChange={(e) => {
                            setRemember(e.currentTarget.checked);
                        }}
                    /> Remember my decision
                </label>
            </div>
            <div className="buttons">
                <Button
                    classes={[ "button-cancel" ]}
                    onClick={() => {
                        props.onComplete(false, remember);
                    }}
                >
                    Block
                </Button>
                <Button
                    classes={[ "button-primary" ]}
                    onClick={() => {
                        props.onComplete(true, remember);
                    }}
                >
                    Allow
                </Button>
            </div>
        </>
    );
};

export default AudioRequestDialog;
